export enum ActorModelState {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	LOCKED = 'LOCKED'
}
